
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';

    // 表单数据模型
    interface FormData {
        id: number;
        inStockNumbersText: string;
        inStockNumbers: string[];
        remark: string;
        isSelf: boolean;
        userId: number;
    }

    @Component({ name: 'BackPrePlanForm' })
    export default class PrePlanForm extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;

        formData: FormData = {
            id: 0,
            inStockNumbersText: '',
            inStockNumbers: [],
            remark: '',
            isSelf: false,
            userId: 0
        };

        formRules = {
            inStockNumbersText: [
                { required: true, message: '请输入入库单号', trigger: 'blur' },
                { validator: this.validateInStockNumbers, trigger: 'blur' }
            ]
        };

        // 监听弹窗显隐
        visibleChange(val: boolean) {
            if (val) {
                this.initForm();
            } else {
                this.resetForm();
            }
        }

        // 初始化表单（编辑时加载Vuex中的模型数据）
        async initForm() {
            const prePlanModel = this.$store.state.backpreplan.stockmodel;
            if (prePlanModel && prePlanModel.id) {
                this.formData.id = prePlanModel.id;
                this.formData.remark = prePlanModel.remark || '';
                this.formData.isSelf = prePlanModel.isSelf || false; // 只读，不允许修改
                if (prePlanModel.planWarehouseStocks && prePlanModel.planWarehouseStocks.length) {
                    const inStockNumbers = prePlanModel.planWarehouseStocks.map(item => item.inStockNumber || '');
                    this.formData.inStockNumbersText = inStockNumbers.filter(Boolean).join('\n');
                }
            } else {
                this.resetForm();
            }
        }

        resetForm() {
            this.formData = {
                id: 0,
                inStockNumbersText: '',
                inStockNumbers: [],
                remark: '',
                isSelf: false,
                userId: 0
            };
            (this.$refs.prePlanForm as any).resetValidation();
        }

        validateInStockNumbers(rule: any, value: string, callback: Function) {
            if (!value || value.trim() === '') {
                callback(new Error('入库单号不能为空'));
                return;
            }
            const inStockNumbers = value.split('\n').map(item => item.trim()).filter(Boolean);
            if (inStockNumbers.length === 0) {
                callback(new Error('请输入有效的入库单号'));
                return;
            }
            callback();
        }

        async handleSubmit() {
            try {
                const formRef = this.$refs.prePlanForm as any;
                await formRef.validate();

                // 处理入库单号数组
                this.formData.inStockNumbers = this.formData.inStockNumbersText
                    .split('\n')
                    .map(item => item.trim())
                    .filter(Boolean)
                    .filter((value, index, self) => self.indexOf(value) === index);

                const submitData = {
                    inStockNumbers: this.formData.inStockNumbers,
                    remark: this.formData.remark,
                    userId: this.formData.userId,
                    isSelf: this.formData.isSelf, // 保持原值，不可修改
                    id: this.formData.id
                };

                await this.$store.dispatch({
                    type: 'backpreplan/create',
                    data: submitData
                });

                this.$Message.success(this.formData.id ? '修改成功！' : '创建成功！');
                this.$emit('input', false);
                this.$emit('save-success');
            } catch (error) {
                this.$Message.error(this.formData.id ? '修改失败！' : '创建失败！');
            }
        }

        handleCancel() {
            this.$emit('input', false);
            this.resetForm();
        }

        beforeDestroy() {
            this.resetForm();
        }
    }
